(function () {
    /**
     * Used for small init functions.
     */

    /**
     * Example plain js foreach function
     */
    const daMenu = () => {
        const jsAnchorBlocks = document.querySelectorAll('.js-anchor-link'),
            anchorNav = document.getElementById('da-anchor-nav');

        const blockIdArray = [];
        const blockTitleArray = [];

        jsAnchorBlocks.forEach((item) => {
            const blockId = item.id;
            const blockTitle = item.querySelector('.block__title').innerHTML;

            blockIdArray.push(blockId);
            blockTitleArray.push(blockTitle);
        });

        let anchorMenu = document.createElement('ul');
        anchorMenu.setAttribute('id', 'da-anchor-menu');
        anchorMenu.setAttribute('class', 'district-attorneys__menu-list');
        anchorNav.append(anchorMenu);

        blockTitleArray.forEach((item, index) => {
            let li = document.createElement('li');
            li.setAttribute('class', 'district-attorneys__menu-list-item');
            let a = document.createElement('a');
            a.innerText = item;
            a.setAttribute('href', '#' + blockIdArray[index]);
            li.append(a);
            anchorMenu.appendChild(li);
        });

        const anchorLinks = document.querySelectorAll('#da-anchor-menu a');
        for (let i = 0; i < anchorLinks.length; i++) {
            anchorLinks[i].addEventListener('click', (event) => {
                if (document.querySelector('.active')) {
                    document
                        .querySelector('.active')
                        .classList.remove('active');
                }

                anchorLinks[i].classList.add('active');
            });
        }

        const anchorNavDropdown = document.querySelector(
            '#da-anchor-nav .dropdown'
        );
        anchorNavDropdown.addEventListener('click', (event) => {
            if (document.querySelector('.active')) {
                document.querySelector('.active').classList.remove('active');
            }

            anchorNavDropdown.classList.add('active');
            anchorMenu.classList.toggle('toggled');
            document.querySelector('.dropdown').classList.toggle('toggled');
            document.getElementById('da-content').scrollIntoView({
                behavior: 'smooth',
            });
        });
    };

    /**
     * Sticky Anchor Nav
     */
    const stickyAnchorNav = () => {
        var waypoint = new Waypoint({
            element: document.getElementById('da-anchor-nav'),
            handler: function (direction) {
                if (direction == 'down') {
                    this.element.classList.add('fixed');
                }

                if (direction == 'up') {
                    this.element.classList.remove('fixed');
                }
            },
            offset: 100,
        });
    };

    /**
     * Stuck Anchor Nav
     */
    const stuckAnchorNav = () => {
        const anchorNav = document.getElementById('da-anchor-nav');
        var waypoint = new Waypoint({
            element: document.getElementById('colophon'),
            handler: function (direction) {
                if (direction == 'down') {
                    anchorNav.classList.add('stuck');
                    anchorNav.classList.remove('fixed');
                }

                if (direction == 'up') {
                    anchorNav.classList.remove('stuck');
                    anchorNav.classList.add('fixed');
                }
            },
            offset: '60%',
        });
    };

    document.addEventListener('DOMContentLoaded', () => {
        daMenu();
        stickyAnchorNav();
        stuckAnchorNav();
    });
})();
